import Button from "@Components/Button";
import styles from "../../../LeadFormModal/LeadFormModal.module.scss";
import useIsDesktop from "hooks/useIsDesktop";
import wrapperHOC from "@Utils/wrapperHOC";

const MIN_PEOPLE = 1;
const MAX_PEOPLE = 10;

const PeopleCount = ({ people, setPeople, testIdPrefix }: any) => {
  const isDesktop = useIsDesktop();

  return (
    <div className={styles.peopleContainer}>
      <div className={styles.peopleDropdownLabel}>Number of People</div>
      <div
        className={styles.peopleInputContainer}
        data-testid={`${testIdPrefix}leadform-number-of-people`}
      >
        <Button
          variant="outline"
          color="secondary5"
          size={isDesktop ? "sm" : "lg"}
          onClick={() => setPeople(people - 1)}
          disable={people === MIN_PEOPLE}
          borderColor="neutral3"
          className={isDesktop ? styles.countButton : styles.common}
          dataTestId={`${testIdPrefix}leadform-numberOfPeople-decrease`}
        >
          -
        </Button>
        <input
          type="number"
          value={people}
          placeholder=""
          onChange={(e) => setPeople(+e)}
          onBlur={() => setPeople(+people > MAX_PEOPLE ? MAX_PEOPLE : people)}
          className={isDesktop ? styles.countInput : styles.common}
          //   showErrorMessage={Boolean(errors.code)}
          //   error={errors.code}
          data-testid={`${testIdPrefix}leadform-input-numberOfPeople`}
        />
        <Button
          variant="outline"
          color="secondary5"
          disable={people === MAX_PEOPLE}
          size={isDesktop ? "sm" : "lg"}
          onClick={() => setPeople(people + 1)}
          borderColor="neutral3"
          className={isDesktop ? styles.countButton : styles.common}
          dataTestId={`${testIdPrefix}leadform-numberOfPeople-increase`}
        >
          +
        </Button>
      </div>
    </div>
  );
};

export default wrapperHOC(PeopleCount, {
  componentName: "PeopleCount-dropdown-LeadForm-Global",
  showForChina: true,
});
